module.exports = __webpack_public_path__ + "static/media/chevron.da0efcbe.svg";